<div [ngClass]="switchClasses">
  <input
    class="form-check-input"
    type="checkbox"
    role="switch"
    [id]="resolvedId"
    [checked]="checked"
    [disabled]="isDisabled"
    [attr.aria-label]="ariaLabel"
    [attr.title]="title ?? ariaLabel"
    (change)="onInputChange($event)"
  />
  <label
    *ngIf="visibleLabel"
    class="form-check-label"
    [attr.for]="resolvedId"
  >
    {{ visibleLabel }}
  </label>
</div>
